var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 214 50.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-1);}.cls-2{fill:#90d0b9;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 214,
    height: 50.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 214,
    height: 50.33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "capio_simple"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m153.61,7.58c0-1.86.57-3.46,1.7-4.79,1.5-1.77,3.77-2.69,6.09-2.69h45.11c2.05,0,3.81.72,5.28,2.15,1.47,1.44,2.2,3.21,2.2,5.33v35.27c0,2.12-.74,3.9-2.2,5.33-1.47,1.43-3.23,2.15-5.28,2.15h-45.11c-2.32,0-4.59-.93-6.09-2.7-1.13-1.33-1.7-2.93-1.7-4.79V7.58Zm53.21,35.9V6.94c0-.1-.09-.19-.19-.19h-44.04c-.99,0-1.8.81-1.8,1.8v33.31c0,.99.81,1.8,1.8,1.8h44.04c.1,0,.19-.08.19-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30.25,50.33H7.5c-2.05,0-3.81-.72-5.29-2.16C.74,46.73,0,44.94,0,42.83V7.5C0,5.37.74,3.6,2.21,2.16,3.69.72,5.44,0,7.5,0h22.75v6.68H7.19v36.98h23.06v6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m67.37,2.16C65.9.72,64.13,0,62.08,0h-22.75v6.68h23.06v12.84H28.9c-2.05,0-3.81.72-5.29,2.16-1.47,1.44-2.21,3.22-2.21,5.34v15.82c0,2.13.74,3.9,2.21,5.34,1.48,1.44,3.24,2.16,5.29,2.16h33.17c2.06,0,3.82-.72,5.29-2.16,1.48-1.44,2.21-3.22,2.21-5.34V7.5c0-2.12-.73-3.9-2.21-5.34m-4.98,41.5H28.6v-17.46h33.79v17.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m148.09,50.33h-6.84V17.59c-3.93,0-7.86-.02-11.79-.03V6.68h-47.13v19.51h47.14v-2.29h7.18c.08,1.42-.04,2.51-.15,3.04-.15.72-.39,1.3-.39,1.3-.12.28-.57,1.35-1.62,2.41-.16.16-.32.31-.48.44-1.35,1.19-2.97,1.78-4.86,1.78h-46.82v17.46h-7.19V7.5c0-2.11.73-3.91,2.2-5.34C78.8.72,80.58,0,82.63,0h46.51c2.06,0,3.82.72,5.3,2.16,1.47,1.44,2.2,3.23,2.2,5.34v2.89h11.36c.02,12.94.05,27,.07,39.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m144.41,0h0c1.99,0,3.59,1.61,3.59,3.59v1.13c0,1.99-1.61,3.59-3.59,3.59s-3.59-1.61-3.59-3.59v-1.13c0-1.99,1.61-3.59,3.59-3.59"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4eab8b2b69c2e5215d5ccbef00b54520.svg";
export { ForwardRef as ReactComponent };